export default {
  setApiVersion (state, version) {
    state.version = version
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js